module.exports = ".table-balance tbody:nth-of-type(odd) {\r\n    background-color:#F5F5F5;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard.component.css
// module id = ./src/app/components/dashboard/dashboard.component.css
// module chunks = main